var _rect, _path, _path2, _rect2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEclipse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#ffab30",
    width: 28,
    height: 28,
    x: -30,
    y: -28,
    rx: 14,
    ry: 14,
    transform: "matrix(0,-1,-1,0,0,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    opacity: 0.2,
    d: "m14 2c-7.756 0-14 6.244-14 14-2.3163e-7 0.169 0.019521 0.333 0.02539 0.5 0.26374-7.5206 6.3874-13.5 13.975-13.5 7.587 0 13.711 5.9794 13.975 13.5 0.005-0.167 0.025-0.331 0.025-0.5 0-7.756-6.244-14-14-14z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m0.02539 16.5c-0.005869 0.167-0.02539 0.331-0.02539 0.5-2.3163e-7 7.756 6.244 14 14 14s14-6.244 14-14c0-0.169-0.02-0.333-0.025-0.5-0.264 7.521-6.388 13.5-13.975 13.5-7.5872 0-13.711-5.979-13.975-13.5z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#5e4095",
    width: 28,
    height: 28,
    x: -30,
    y: -32,
    rx: 14,
    ry: 14,
    transform: "matrix(0,-1,-1,0,0,0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m4.9297 12c-0.2461 0.646-0.4522 1.311-0.6016 2h27.344c-0.15-0.689-0.356-1.354-0.602-2h-26.14zm-0.8789 4c-0.0117 0.166-0.0156 0.335-0.0254 0.502 0.0178 0.507 0.0628 1.006 0.1328 1.498h27.684c0.07-0.492 0.115-0.991 0.133-1.498-0.01-0.167-0.014-0.336-0.026-0.502h-27.898zm0.5312 4c0.205 0.693 0.471 1.357 0.7754 2h25.286c0.304-0.643 0.57-1.307 0.775-2h-26.836z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    opacity: 0.8,
    d: "m4.9297 11c-0.2461 0.646-0.4522 1.311-0.6016 2h27.344c-0.15-0.689-0.356-1.354-0.602-2h-26.14zm-0.8789 4c-0.0233 0.332-0.0508 0.662-0.0508 1s0.0275 0.668 0.0508 1h27.898c0.023-0.332 0.051-0.662 0.051-1s-0.028-0.668-0.051-1h-27.898zm0.2773 4c0.1494 0.689 0.3555 1.354 0.6016 2h26.14c0.246-0.646 0.452-1.311 0.602-2h-27.344z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    opacity: 0.1,
    d: "m18 2c-7.756 0-14 6.244-14 14 0 0.16884 0.0195 0.33264 0.0254 0.5 0.2641-7.5206 6.388-13.5 13.975-13.5 7.5872 0 13.711 5.9794 13.975 13.5 0.006-0.16736 0.0254-0.33116 0.0254-0.5 0-7.756-6.244-14-14-14z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m18 31c-7.756 0-14-6.244-14-14 0-0.169 0.0195-0.333 0.0254-0.5 0.2637 7.521 6.3876 13.5 13.975 13.5 7.5872 0 13.711-5.9794 13.975-13.5 0.006 0.16736 0.0254 0.33116 0.0254 0.5 0 7.756-6.244 14-14 14z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEclipse);
export default __webpack_public_path__ + "static/media/eclipse.0968d941129b38f023d30c4469fefe69.svg";
export { ForwardRef as ReactComponent };